import React from 'react';
import env from '@beam-australia/react-env';
import { loggerFunc } from 'utils/logger';
import MyRac from './views/MyRac/MyRac';

const logger = loggerFunc('App');

const App = () => {
  logger.info(`My Rac has Started. version: ${env('VERSION')}`);

  return (
    <MyRac />
  );
};

export default App;
